const AuthRoutes = {
    login: 'admin/login',
    changePassword: 'admin/changepassword',
};

export default AuthRoutes